module.exports = __webpack_public_path__ + "/login_ui/img/ke-48e2f2cbada4b345ca9457ae718526a6.svg";